module.exports = __webpack_public_path__ + "static/media/grossRevenueGradient.de6115e6.svg";